import React, { Component } from 'react';
import './ButtonWithImage.scss';

class ButtonWithImage extends Component {
  componentDidMount() {}

  render() {
    const { imageUrl, iconStyles, buttonLbl, styles, handleClick } = this.props;
    return (
      <div className='button-with-image'>
        <div
          role='button'
          tabIndex='0'
          className='hp-click-btn'
          style={styles}
          onClick={handleClick}
          onKeyPress={() => []}
        >
          <span>
            <img src={imageUrl} alt='' style={iconStyles} />
          </span>
          <span className='hp-click-lbl'>{buttonLbl}</span>
        </div>
      </div>
    );
  }
}

export default ButtonWithImage;
